import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Http, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { Injectable } from '@angular/core';
import { URLSearchParams } from '@angular/http';
import axios, { AxiosResponse } from 'axios';

import { environment } from '../../environments/environment';

let HOST = environment.apiHost;

@Injectable()
export class HomeService {

    constructor(private http: Http, private httpClient:HttpClient) { }


    sendActivity(param, data?: any): Promise<any> {
        const headers = {
            'Content-Type': 'application/json'
        };

        const requestBody = {
            file: param.file,
            action: param.action,
            user: param.user
        };

        return this.httpClient.post(HOST + '/send_activity', requestBody, { headers })
            .toPromise()
            .then(response => response)
            .catch(err => err);

    }

    sendReleaseBundleData(param, data?: any): Promise<any> {
        const headers = {
            'Content-Type': 'application/json'
        };

        const requestBody = {
            bundle_id: param.bundle_id,
            version: param.version,
            release_id: param.release_id,
            component: param.component,
            connect: param.connect
        };

        return this.httpClient.post(HOST + '/add-release-bundle-data', requestBody, { headers })
            .toPromise()
            .then(response => response)
            .catch(err => err);


        // const params: URLSearchParams = new URLSearchParams();
        // params.set('bundle_id', param.bundle_id);
        // params.set('version', param.version);
        // params.set('release_id', param.release_id);
        // params.set('component', param.component);
        // params.set('connect', param.connect);

        // return this.http.post(HOST + '/add-release-bundle-data', params)
        //     .toPromise()
        //     .then(response => {
        //         return response.json();
        //     })
        //     .catch(err => err);
    }

    getReleaseBundleData(param, data?: any): Promise<any> {

        const params: URLSearchParams = new URLSearchParams();
        params.set('bundle_id', param.bundle_id);

        return this.http.post(HOST + '/get-release-bundle-data', params)
            .toPromise()
            .then(response => {
                return response.json();
            })
            .catch(err => err);
    }


    getBundleDownloadData(param, data?: any): Promise<any> {
        const headers = {
            'Content-Type': 'application/json'
        };

        const requestBody = {
            bundle_id: param.bundle_id
        };

        return this.httpClient.post(HOST + '/get-bundle-download-data', requestBody, { headers })
            .toPromise()
            .then(response => response)
            .catch(err => err);

        // const params: URLSearchParams = new URLSearchParams();
        // params.set('bundle_id', param.bundle_id);

        // return this.http.post(HOST + '/get-bundle-download-data', params)
        //     .toPromise()
        //     .then(response => {
        //         return response.json();
        //     })
        //     .catch(err => err);
    }

   // downloadFile(param, data?: any): Promise<any> {

    //    const params: URLSearchParams = new URLSearchParams();
   //     params.set('locaction', param.locaction);

   //     return this.http.post(HOST + '/downloadParams', params)
   //         .toPromise()
  //          .then(response => {
   //             return response.json();
  //          })
  //          .catch(err => err);
//
 //   }
//
    getArchiveDownloadURL(param, data?: any): Promise<any> {

        const headers = {
            'Content-Type': 'application/json'
        };

        const requestBody = {
            locationList: param.locationList,
            fileList: param.fileList,
            bundle_name: param.bundle_name
        };

        return this.httpClient.post(HOST + '/download-archive', requestBody, { headers })
            .toPromise()
            .then(response => response)
            .catch(err => err);

        // const params: URLSearchParams = new URLSearchParams();
        // params.set('locationList', param.locationList);
        // params.set('fileList', param.fileList);
        // params.set('bundle_name', param.bundle_name);

        // return this.http.post(HOST + '/download-archive', params)
        //     .toPromise()
        //     .then(response => {
        //         return response.json();
        //     })
        //     .catch(err => err);
    }

    // getArchiveDownloadURL(param, data?: any): Promise<any> {

    //     const params: URLSearchParams = new URLSearchParams();
    //     params.set('locationList', param.locationList);
    //     params.set('fileList', param.fileList);
    //     params.set('bundle_name', param.bundle_name);

    //     return this.http.post(HOST + '/download-archive', params)
    //         .toPromise()
    //         .then(response => {
    //             return response.json();
    //         })
    //         .catch(err => err);
    // }

    getArchiveDownload(param, data?: any): Promise<any> {

        const params: URLSearchParams = new URLSearchParams();
        params.set('URL', param.URL);

        return this.http.get(HOST + '/download-zip')
            .toPromise()
            .then(response => {
                return response.json();
            })
            .catch(err => err);
    }



    getReleaseVersionForBundle(param, data?: any): Promise<any> {

        const headers = {
            'Content-Type': 'application/json'
        };

        const requestBody = {
            bundle_id: param.bundle_id,
            project_id: param.project_id
        };

        return this.httpClient.post(HOST + '/release-version-bundles', requestBody, { headers })
            .toPromise()
            .then(response => response)
            .catch(err => err);

        // const params: URLSearchParams = new URLSearchParams();
        // params.set('bundle_id', param.bundle_id);
        // params.set('project_id', param.project_id);

        // return this.http.post(HOST + '/release-version-bundles', params)
        //     .toPromise()
        //     .then(response => {
        //         return response.json();
        //     })
        //     .catch(err => err);
    }


    sendEditData(param, data?: any): Promise<any> {
        const headers = {
            'Content-Type': 'application/json'
        };

         // Convert cc to a single value if it's an array
        const ccValue = Array.isArray(param.cc) ? param.cc[0] : param.cc;

        const requestBody = {
            release_id: param.release_id,
            project: param.project,
            component: param.component,
            version: param.version,
            desc: param.desc,
            fileName: param.fileName,
            owner: param.owner,
            destination: param.destination,
            note: param.note,
            relaseNote: param.relaseNote,
            test: param.test,
            testCases: param.testCases,
            updated_by: param.updated_by,
            workflow: param.workflow,
            qa: param.qa,
            cc: ccValue // Use the converted value here
        };

        return this.httpClient.post(HOST + '/edit', requestBody, { headers })
            .toPromise()
            .then(response => response)
            .catch(err => err);

        // const params: URLSearchParams = new URLSearchParams();
        // params.set('release_id', param.release_id);
        // params.set('project', param.project);
        // params.set('component', param.component);
        // params.set('version', param.version);
        // params.set('desc', param.desc);
        // params.set('fileName', param.fileName);
        // params.set('owner', param.owner);
        // params.set('destination', param.destination);
        // params.set('note', param.note);
        // params.set('relaseNote', param.relaseNote);
        // params.set('test', param.test);
        // params.set('testCases', param.testCases);
        // params.set('updated_by', param.updated_by);
        // params.set('workflow', param.workflow);
        // params.set('qa', param.qa);
        // params.set('cc', param.cc);

        // return this.http.post(HOST + '/edit', params)
        //     .toPromise()
        //     .then(response => {
        //         return response.json();
        //     })
        //     .catch(err => err);

    }


    getReleaseComponents(param, data?: any): Promise<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        const requestBody = {
            fromdate: param.fd,
            todate: param.td,
            user: param.user
        };
       
        return this.httpClient.post(HOST + '/release-comp', requestBody, { headers })
        .toPromise()
        .then(response => response)
        .catch(err => err);
    }

    getReleaseData(param, data?: any): Promise<any> {
        const headers = {
            'Content-Type': 'application/json'
        };
        
        const requestBody = {
            fromdate: param.fd,
            todate: param.td,
            project: param.p,
            component: param.c,
            projectList: param.pList,
            componentList: param.cList,
            workflow: param.workflow,
            release_id: param.release_id,
            user: param.user
        };

        return this.httpClient.post(HOST + '/release', requestBody, { headers })
            .toPromise()
            .then(response => response)
            .catch(err => err);


        // const params: URLSearchParams = new URLSearchParams();
        // params.set('fromdate', param.fd);
        // params.set('todate', param.td);
        // params.set('project', param.p);
        // params.set('component', param.c);
        // params.set('projectList', param.pList);
        // params.set('componentList', param.cList);
        // params.set('workflow', param.workflow);
        // params.set('release_id', param.release_id);
        // params.set('user', param.user);

        // return this.http.post(HOST + '/release', params)
        //     .toPromise()
        //     .then(response => {
        //         return response.json();
        //     })
        //     .catch(err => err);

    }

    // getReleaseData(param, data?: any): Promise<any> {
    //     const headers = new HttpHeaders({
    //         'Content-Type': 'application/json'
    //     });
    
    //     const requestBody = {
    //         fromdate: param.fd,
    //         todate: param.td,
    //         project: param.p,
    //         component: param.c,
    //         projectList: param.pList,
    //         componentList: param.cList,
    //         workflow: param.workflow,
    //         release_id: param.release_id,
    //         user: param.user
    //     };
    
    //     return this.httpClient.post(HOST + '/release', requestBody, { headers })
    //         .toPromise()
    //         .then(response => response)
    //         .catch(err => err);
    // }

    // async getReleaseComponents(param, data?: any): Promise<any> {
    //     const headers = {
    //         'Content-Type': 'application/json'
    //     };

    //     const requestBody = {
    //         fromdate: param.fd,
    //         todate: param.td,
    //         user: param.user
    //     };

    //     try {
    //         const response: AxiosResponse = await axios.post(HOST + '/release-comp', requestBody, { headers });
    //         return response.data;
    //     } catch (error) {
    //         return error;
    //     }
    // }
    
    // async getReleaseData(param: any, data?: any): Promise<any> {
    //     const headers = {
    //         'Content-Type': 'application/json'
    //     };
    
    //     const requestBody = {
    //         fromdate: param.fd,
    //         todate: param.td,
    //         project: param.p,
    //         component: param.c,
    //         projectList: param.pList,
    //         componentList: param.cList,
    //         workflow: param.workflow,
    //         release_id: param.release_id,
    //         user: param.user
    //     };
    
    //     try {
    //         const response: AxiosResponse = await axios.post(HOST + '/release', requestBody, { headers });
    //         return response.data;
    //     } catch (error) {
    //         return error;
    //     }
    // }
    

    downloadFile(param, data?: any): Promise<any> {

        const params: URLSearchParams = new URLSearchParams();
        params.set('locaction', param.locaction);

        return this.http.post(HOST + '/downloadParams', params)
            .toPromise()
            .then(response => {
                return response.json();
            })
            .catch(err => err);

    }

    download() {
        // const headers = {
        //     'Content-Type': 'application/zip'
        // };
        
        // return this.httpClient.get(HOST + '/download', { headers, responseType: 'blob' })
        //     .toPromise()
        //     .then(response => response)
        //     .catch(err => err);

        return this.http.get(HOST + '/download')
            .toPromise()
            .then(response => {
                return response.json();
            })
            .catch(err => err);
    }

    discardRelease(param, data?: any): Promise<any> {

        const headers = {
            'Content-Type': 'application/json'
        };

        const requestBody = {
            id: param.id
        };

        return this.httpClient.post(HOST + '/discard', requestBody, { headers })
            .toPromise()
            .then(response => response)
            .catch(err => err);

        // const params: URLSearchParams = new URLSearchParams();
        // params.set('id', param.id);

        // return this.http.post(HOST + '/discard', params)
        //     .toPromise()
        //     .then(response => {
        //         return response.json();
        //     })
        //     .catch(err => err);

    }

    rejectRelease(param, data?: any): Promise<any> {

        const params: URLSearchParams = new URLSearchParams();
        params.set('id', param.id);

        return this.http.post(HOST + '/reject', params)
            .toPromise()
            .then(response => {
                return response.json();
            })
            .catch(err => err);

    }

    updateQA(param, data?: any): Promise<any> {

        const params: URLSearchParams = new URLSearchParams();
        params.set('release_id', param.release_id);
        params.set('qa', param.qa);

        return this.http.post(HOST + '/update-QA', params)
            .toPromise()
            .then(response => {
                return response.json();
            })
            .catch(err => err);

    }

}
